module.exports = __webpack_public_path__ + "media/images/about-pic3-5a082b4d.png";